<template>
  <div class="rp-actions">
    <button type="button" class="btn btn-light rp-reset" :disabled="!canReset" @click="$emit('reset')">
      <i class="ti ti-refresh me-1"></i>Reset
    </button>
    <button type="button" class="btn rp-btn rp-btn-pdf" :disabled="!!exporting || loading" @click="$emit('export', 'pdf')">
      <span v-if="exporting === 'pdf'" class="spinner-border spinner-border-sm me-1"></span>
      <i v-else class="ti ti-file-type-pdf me-1"></i>PDF
    </button>
    <button type="button" class="btn rp-btn rp-btn-excel" :disabled="!!exporting || loading" @click="$emit('export', 'xlsx')">
      <span v-if="exporting === 'xlsx'" class="spinner-border spinner-border-sm me-1"></span>
      <i v-else class="ti ti-file-spreadsheet me-1"></i>Excel
    </button>
    <button type="button" class="btn rp-btn rp-btn-print" :disabled="loading || !canPrint" @click="$emit('print')">
      <i class="ti ti-printer me-1"></i>Print
    </button>
  </div>
</template>

<script>
/** Reset / PDF / Excel / Print buttons of the inventory reports. */
export default {
  name: 'ReportActions',
  props: {
    loading: { type: Boolean, default: false },
    exporting: { type: String, default: '' },
    canReset: { type: Boolean, default: false },
    canPrint: { type: Boolean, default: false },
  },
  emits: ['reset', 'export', 'print'],
};
</script>

<style scoped src="./inventoryReport.css"></style>
